import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import ReactApexChart from "react-apexcharts";
import { numberWithCommas, capitalizeFirstLetter } from "../../helpers/utils";

class CustomSplineArea extends Component {
  constructor(props) {
    super(props);
    this.state = {
      series: [
        {
          name: "Profit",
          data: [],
        },
      ],
      options: {
        chart: {
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "50%",
            endingShape: "rounded",
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 1,
          colors: ["transparent"],
        },
        colors: ["#556ee6", "#f46a6a"],
        xaxis: {
          type: "datetime",
          labels: {
            datetimeFormatter: {
              year: "yyyy",
              month: "MMM 'yyyy",
              day: "dd MMM",
              hour: "HH:mm",
            },
          },
        },
        yaxis: {
          title: {
            text: "PROFIT BY EACH DAY",
          },
        },
        grid: {
          borderColor: "#f1f1f1",
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          enabled: true,
          y: {
            formatter: value =>
              `${numberWithCommas(parseFloat(value))} ${
                (this.props.currency && this.props.currency) || ""
              }`,
            title: {
              formatter: tooltipName =>
                capitalizeFirstLetter(tooltipName) + ":",
            },
          },
        },
      },
    };
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.data !== this.props.data) {
      let data = this.props.data.sort((a, b) => {
        return new Date(a.date) - new Date(b.date);
      });

      let upd = [];

      this.props.data.map(i => {
        upd.push({
          x: i.date,
          y: i.profit,
        });
      });

      let options = this.state.options;
      options.xaxis.categories = data.map(i => {
        return i.date;
      });

      this.setState({
        series: [
          {
            name: "Profit",
            data: upd,
          },
        ],
        options,
      });
    }
  }

  render() {
    return (
      <React.Fragment>
        <ReactApexChart
          options={this.state.options}
          series={this.state.series}
          type="area"
          height={350}
          className="apex-charts"
        />
      </React.Fragment>
    );
  }
}

CustomSplineArea.propTypes = {
  onChange: PropTypes.func,
  data: PropTypes.any,
  currency: PropTypes.string,
};

export default CustomSplineArea;
